// extracted by mini-css-extract-plugin
export default {"modal":"ImportCandidatesModal-module__modal__LUmwn","content":"ImportCandidatesModal-module__content__e85mi"};